import { createReducer, on } from '@ngrx/store';
import { StationsActions } from './stations.actions';
import {StationGnvList} from '../../../swagger-gen/gnvert-secured/models/station-gnv-list';

export const stationsFeatureKey = 'Stations';

export interface StationsState {
    stations: StationGnvList;
    errorMessage: string | null;
    loading: boolean;
    hasError: boolean;
}

export const initialStation: StationsState = {
    stations: [],
    errorMessage: null,
    loading: true,
    hasError: false
};

export const stationsReducer = createReducer(
    initialStation,
    on(
        StationsActions.fetchSuccess,
        (state, { response }): StationsState => ({
            ...state,
            stations: response,
            loading: false,
            errorMessage: null,
            hasError: false
        })
    ),
    on(StationsActions.fetchFailure,
        (state, {message}) => ({
            ...state,
            errorMessage: message,
            loading: false,
            hasError: true
        })
    )
);
